import { QueryClient } from "@tanstack/react-query";

import { STALE_TIME_L } from "#app/http/ReactQueryProvider";
import {
  fetchCustomMaterials,
  CustomMaterialsDto,
} from "#modules/materials/infra/fetchCustomMaterials.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const customMaterialsQuery = () => ({
  queryKey: queryKeys.materials.custom,
  queryFn: () => fetchCustomMaterials(),
  staleTime: STALE_TIME_L,
});

export const getCustomMaterialsQueryData = (
  queryClient: QueryClient,
): CustomMaterialsDto | undefined => {
  return queryClient.getQueryData<CustomMaterialsDto>(queryKeys.materials.custom);
};

type CustomMaterialsQueryDataUpdater =
  | CustomMaterialsDto
  | undefined
  | ((old: CustomMaterialsDto | undefined) => CustomMaterialsDto | undefined);

export const setCustomMaterialsQueryData = (
  queryClient: QueryClient,
  updater: CustomMaterialsQueryDataUpdater,
): CustomMaterialsDto | undefined => {
  return queryClient.setQueryData<CustomMaterialsDto>(queryKeys.materials.custom, updater);
};
